import { render } from "./TargetsTour.vue?vue&type=template&id=e322b92a"
import script from "./TargetsTour.vue?vue&type=script&lang=js"
export * from "./TargetsTour.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__